import { render, staticRenderFns } from "./Yampiv2.vue?vue&type=template&id=8780e640&scoped=true&"
import script from "./Yampiv2.vue?vue&type=script&lang=js&"
export * from "./Yampiv2.vue?vue&type=script&lang=js&"
import style0 from "./Yampiv2.vue?vue&type=style&index=0&id=8780e640&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8780e640",
  null
  
)

export default component.exports